module.exports = __webpack_public_path__ + "img/st-banner.f44a3136.png";